import { Hint } from 'components';
import { useTranslation } from 'libs/i18n';
import { ListTypography, Stack, Typography } from 'libs/ui';
import { RegistrationType } from 'modules/auth/registration/types';

import { HintContainer } from './styles';

interface Props {
  registrationType: RegistrationType;
}

export const SubTitle = ({ registrationType }: Props) => {
  const { t } = useTranslation();

  return (
    <Typography as="p" datax="onboarding-subtitle" variantMobile="caption">
      {t(`auth.registration.USTaxStatus.${registrationType}.subtitle`)}
      <HintContainer>
        {registrationType === RegistrationType.personal ? (
          <Hint
            title={
              <Typography variant="caption">
                {t('auth.registration.USTaxStatus.personal.hint')}
              </Typography>
            }
          />
        ) : (
          <Hint
            title={
              <Stack spacing={4}>
                <Typography variant="bodyBold">
                  {t('auth.registration.USTaxStatus.legal.hint.title')}
                </Typography>
                <ListTypography
                  listType="ul"
                  texts={t('auth.registration.USTaxStatus.legal.hint.texts', {
                    returnObjects: true,
                  })}
                  variant="caption"
                />
              </Stack>
            }
          />
        )}
      </HintContainer>
    </Typography>
  );
};
